import { render, staticRenderFns } from "./OrdersAllView.vue?vue&type=template&id=c5fd18d8"
import script from "./OrdersAllView.vue?vue&type=script&lang=js"
export * from "./OrdersAllView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports